import { __assign, __rest } from "tslib";
import React from 'react';
import { MetricChart } from '@keen.io/charts';
import { Card } from '@keen.io/ui-core';
import WidgetHeading from '../widget-heading.component';
import { Container, HeadingPosition } from './metric.widget.styles';
var Widget = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, tags = _a.tags, props = __rest(_a, ["title", "subtitle", "tags"]);
    return (React.createElement(Container, null,
        React.createElement(MetricChart, __assign({}, props)),
        React.createElement(HeadingPosition, null,
            React.createElement(WidgetHeading, { title: title, subtitle: subtitle, tags: tags }))));
};
export var MetricChartWidget = function (_a) {
    var card = _a.card, title = _a.title, subtitle = _a.subtitle, tags = _a.tags, props = __rest(_a, ["card", "title", "subtitle", "tags"]);
    return (React.createElement(Card, __assign({}, card, { hideOverflow: true }),
        React.createElement(Widget, __assign({ title: title, subtitle: subtitle, tags: tags }, props))));
};
export default MetricChartWidget;
